module.exports = __webpack_public_path__ + "static/media/station00.aadf280c.png";